import countries from 'i18n-iso-countries';
import deutsch from 'i18n-iso-countries/langs/de.json';
import english from 'i18n-iso-countries/langs/en.json';

countries.registerLocale(deutsch);
countries.registerLocale(english);

const ALPHA2_LENGTH = 2;

const SUPPORTED_LOCALES = ['de', 'en'] as const;

const resolveLocale = (lng: string | undefined): string => {
  const primary = (lng || '').toLowerCase().split('-')[0];
  return SUPPORTED_LOCALES.find((locale) => locale === primary) ?? SUPPORTED_LOCALES[0];
};

export const countryOptions = (lng: string | undefined) => {
  const locale = resolveLocale(lng);
  return Object.entries(countries.getNames(locale))
    .map(([code, name]) => ({ text: name, value: code }))
    .sort((a, b) => a.text.localeCompare(b.text, locale));
};

export const countryAlpha2 = (value: string | null | undefined): string | undefined => {
  if (!value) return undefined;

  const upper = value.trim().toUpperCase();
  if (upper.length === ALPHA2_LENGTH && countries.isValid(upper)) return upper;

  return (
    countries.alpha3ToAlpha2(upper) ||
    countries.getAlpha2Code(value, 'de') ||
    countries.getAlpha2Code(value, 'en') ||
    undefined
  );
};

export const countryLabel = (value: string | null | undefined, lng: string | undefined): string => {
  if (!value) return '';
  const alpha2 = countryAlpha2(value);
  return (alpha2 && countries.getName(alpha2, resolveLocale(lng))) || value;
};
